import { GetServerSideProps } from "next";
import React, { Props, useEffect, useState } from "react";
import Link from "next/link";
import ErrorScreen from "../../components/ui/error-screen";
import { AppBtn } from "../../components/ui/buttons";
import { generateComplementaryHexColor3, hexToRgb, isValidHexCode, reloadPage } from "../../assets/js/utils/functions";
import SEOTags from "../../components/seo-tags";
import useAnalytics, { PAGE_TYPE } from "../../components/hooks/analytics";
import CartContext from "../../contexts/cart-context";
import ProductPageDetails from "../../components/products/product-page-details";
import { AccountInformation, ProductItemInterface, STORE_VERSION, StoreInterface } from "../../assets/interfaces";
import LazyImage from "../../components/lazy-image";
import useSlider from "../../components/hooks/useSlider";
import Portal from "../../components/portal";
import { checkStoreIsOpen, getItemThumbnail, getWhatsappLink } from "../../assets/js/utils/utils";
import { useFetcher, useRequest } from "../../api/utils";
import { GetStoreBankAccount } from "../../api/stores";
import ProductPageHeader from "../../components/products/header";
import ProductDetailsSection from "@/components/storefronts-v2/items/product-details-section";
import { Cart } from "@/components/storefronts-v2/sections";
import CartContextV2 from "@/contexts/cart-context-v2";
import { VisitRoute } from "@/contexts/storefront";
import ProductPageV2, { ProductPageProps } from "@/components/storefronts-v2/product-page";
import StorefrontContext from "@/contexts/storefront";
import { NotFoundMain } from "../404";
import ProductPageV1 from "@/components/storefronts-v1/product-page";

const ProductPage: React.FC<ProductPageProps> = (props) => {
  if (!props.item || props.error) {
    return <NotFoundMain />;
  }

  return (
    <StorefrontContext.Provider initialState={{ route: VisitRoute.SLUG, store: props.item?.store }}>
      {props.item?.store?.flags?.storefront_version === STORE_VERSION.V1 ? (
        <ProductPageV1 {...props} />
      ) : (
        <ProductPageV2 {...props} />
      )}
    </StorefrontContext.Provider>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = context.params.slug as string;
  const query = context.query;

  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/items/public/${slug}`);

    if (res.ok) {
      const data = await res.json();

      if (!data.data) {
        //switch to custom not-found
        return {
          notFound: true,
        };
      }

      return {
        props: {
          item: data.data,
          error: false,
          query,
        },
      };
    }

    if (res.status === 404) {
      return {
        notFound: true,
      };
    }

    throw Error;
  } catch (e) {
    return {
      props: {
        error: true,
        item: null,
      },
    };
  }
};

export default ProductPage;
